import React from 'react';
import { Card, CardMedia, Typography } from '@mui/material';
import './LoginBanner.css'; // Import the CSS file

const LoginBanner = () => {
  return (
    <Card sx={{
      width: '100vw',
      maxWidth: '100%',
      m: 0,
      p: 0,
      boxSizing: 'border-box',
      position: 'relative',
    }}>
      <Typography 
        variant="h3" 
        className="login-banner-text" 
      >
       Compliance. <br/>  Simplified!
      </Typography>
      <CardMedia
        component="img"
        image="/assets/images/ZaviorLogin960.png"
        alt="Compliance Simplified"
        title="Compliance Simplified"
        className="login-banner-media" 
      />
    </Card>
  );
};

export default LoginBanner;
